/**
 * Estado da sidebar: accordion de módulos, rail do desktop e off-canvas mobile.
 *
 * Registrado como `Alpine.data('sidebar')` e declarado no <body>, porque o
 * botão que abre o off-canvas fica no header, fora do <aside>.
 */

const GROUP_KEY = 'meta.sidebar.group';
const COLLAPSED_KEY = 'meta.sidebar.collapsed';
const COLLAPSED_CLASS = 'sidebar-is-collapsed';

// localStorage pode estar indisponível (modo privativo, política de navegador).
// Nesses casos a sidebar funciona com o estado padrão.
function read(key) {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
}

function write(key, value) {
    try {
        window.localStorage.setItem(key, value);
    } catch (e) {
        // Ignorado de propósito: a persistência é uma conveniência.
    }
}

function groups() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-group]'));
}

export default function sidebar() {
    return {
        collapsed: false,
        mobileOpen: false,
        openGroup: null,
        mobileTrigger: null,

        init() {
            // A classe já foi aplicada em <html> pelo script inline do <head>,
            // antes da primeira pintura; aqui só espelhamos no estado.
            this.collapsed = document.documentElement.classList.contains(COLLAPSED_CLASS);
            this.openGroup = this.resolveOpenGroup();
        },

        /**
         * Precedência: rota atual > valor salvo > primeiro grupo do usuário.
         */
        resolveOpenGroup() {
            const byRoute = document.querySelector('[data-group-active="exact"]')
                || document.querySelector('[data-group-active="within"]');

            if (byRoute) {
                return byRoute.getAttribute('data-group');
            }

            const stored = read(GROUP_KEY);

            if (stored === null) {
                const first = groups()[0];
                return first ? first.getAttribute('data-group') : null;
            }

            // String vazia = o usuário fechou tudo de propósito.
            if (stored === '') {
                return null;
            }

            const known = groups().some(function (el) {
                return el.getAttribute('data-group') === stored;
            });

            return known ? stored : null;
        },

        isGroupOpen(id) {
            return this.openGroup === id;
        },

        /** Accordion: abrir um grupo fecha os demais. */
        toggleGroup(id) {
            this.openGroup = this.openGroup === id ? null : id;
            write(GROUP_KEY, this.openGroup === null ? '' : this.openGroup);
        },

        toggleCollapsed() {
            this.collapsed = ! this.collapsed;
            document.documentElement.classList.toggle(COLLAPSED_CLASS, this.collapsed);
            write(COLLAPSED_KEY, this.collapsed ? '1' : '0');
        },

        openMobile(event) {
            this.mobileTrigger = event && event.currentTarget ? event.currentTarget : null;
            this.mobileOpen = true;
        },

        closeMobile() {
            if (! this.mobileOpen) {
                return;
            }

            this.mobileOpen = false;

            // Devolve o foco ao botão que abriu o off-canvas.
            if (this.mobileTrigger && typeof this.mobileTrigger.focus === 'function') {
                this.mobileTrigger.focus();
            }
        },
    };
}
